import React, { useEffect, useRef } from 'react'
import Header from '../landing/Header/Header'

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Breadcrumb } from 'react-bootstrap';
gsap.registerPlugin(ScrollTrigger);


const Browsebanner = () => {
    const textRef = useRef(null);
    const paraRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline();

        gsap.set(textRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(textRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
        });
    }, []);

    useEffect(() => {
        gsap.fromTo(
            paraRef.current,
            { opacity: 0, y: 50 },
            { opacity: 1, y: 0, duration: 1, ease: "power2.out" }
        );
    }, []);

    useEffect(() => {
        const tl = gsap.timeline();

        gsap.set(buttonRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });


        tl.to(buttonRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 0.5,
            ease: "power2.out",
        })

            .to(buttonRef.current, {
                rotateY: 360,
                duration: 0.8,
                ease: "power2.inOut",
            });
    }, []);

    useEffect(() => {
        gsap.from(".breadvrumbcnt, .breadvrumbcntactive", {
            opacity: 0,
            y: 10,
            duration: 0.6,
            stagger: 0.2,
            ease: "power2.out",
        });
    }, []);
    useEffect(() => {
        gsap.fromTo(".fade-element", { x: 100, opacity: 0, }, { x: 0, opacity: 1, duration: 1 });
    }, []);

    const breadcrumbSchema = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://tomi.com/"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "Build Groups", // ✅ Level 2 in JSON
                "item": "https://tomi.com/buildgroup"
            }
        ]
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.innerHTML = JSON.stringify(breadcrumbSchema);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    return (
        <section className="bannermainprnt">
            <Header />
            <div className="custom-container ">

                <div className="heromain">
                    <div className="heroleftseaction">
                        <div className="textherobanner">
                            <nav aria-label="breadcrumb">
                                <Breadcrumb className="breadcrumbprnt">
                                    <Breadcrumb.Item className="breadvrumbcnt" href="/">
                                        Home
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item className="breadvrumbcnt" href="/feature">
                                        Features
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item
                                        className="breadvrumbcntactive"
                                    >
                                        Build Groups
                                    </Breadcrumb.Item>
                                </Breadcrumb>
                            </nav>
                            <h1 ref={textRef}>Empowering leaders, protecting followers.</h1>
                            <p ref={paraRef}>Groups redefine communities by merging messaging, payments, and Web3 privacy. Leaders can shine and monetize, while followers engage anonymously and securely.</p>

                        </div>
                        <button ref={buttonRef} data-bs-toggle="modal"
                            data-bs-target="#exampleModal" className="herofeaturebannerbtn bannerbuildbtn primerybtn">
                            Get Early Access
                        </button>
                    </div>
                    <div className="herorightseaction noneinmobileview">
                        <img className="img-fluid fade-element" src="\assets\Buildimgs\browslandingbannerimg.png" alt="img" />
                    </div>
                    <div className="herorightseaction d-none showinmobileview" style={{ position: "relative" }}>
                        <img className="img-fluid fade-element d-block m-auto" src="\assets\Buildimgs\browslandingbannerimgmbl.png" alt="img" style={{ maxWidth: "60%" }} />
                        <img className="img-fluid mblbgviewcenterbackside" src="\assets\mblbgviewcenterbackside.png" alt="img" />
                    </div>
                </div>
            </div>
        </section >
    )
}

export default Browsebanner